import { ConstraintOperator } from './constraint-operator'
import { PropertySpec } from '../../../properties/spec/property-spec'

export class ConstraintSpec extends PropertySpec {
  public id: string

  public operator: ConstraintOperator

  public matchIfMissingProp: boolean

  public description: string
}
